import { action, ActionType } from 'typesafe-actions';
import {containers,actionTypes,uiItemNames} from '../types/enums'
import {UiItemsTypes} from '../types/types'
import rootReducer from '../reducers/index';
import * as actions from './folderViewActions';
import { ThunkDispatch } from 'redux-thunk';
import store from '../configureStore';

//set loading/visible/error state for containers
export const setUiProperty = (actionType:actionTypes, scope:containers, value:boolean) => {
    return action(actionType,{scope,value});
};

//set ui item values for containers
export const setStateItem = (actionType:actionTypes, items:uiItemNames, value:UiItemsTypes) => {
    return action(actionType,{items,value,});
};

//set ui item values for containers
export const setUser = (actionType:actionTypes, value:any) => {
    return action(actionType,value);
};

export const setAppSettings = (actionType:actionTypes, value:any) => {
    return action(actionType,value);
};

//all folder view actions
type RootState = ReturnType<typeof rootReducer>;
type RootAction = ActionType<typeof actions>;
type ThunkDispatchFix = ThunkDispatch<RootState, unknown, RootAction>;

export const dispatch = store.dispatch as ThunkDispatchFix;


